import type { PendingSave } from "./artifact-save-request"

/**
 * Writes a confirmed artifact export to disk (APP-3495).
 *
 * The app does this, not the artifact: the frame's sandbox has no `allow-downloads`, so nothing on
 * the far side of it can reach a real save. By the time this runs the request has been validated and
 * the user has named-and-confirmed the file.
 */
export function saveArtifactFile({ blob, filename, contentType }: PendingSave): void {
  // Re-typed to the validated media type: the artifact's own Blob carries whatever type it chose, and
  // this is the one that reaches the disk. `slice` rather than `new Blob([blob])` so the bytes are
  // re-labelled instead of copied.
  const url = URL.createObjectURL(blob.slice(0, blob.size, contentType))

  const anchor = document.createElement("a")

  try {
    anchor.href = url
    anchor.download = filename
    document.body.appendChild(anchor)
    anchor.click()
  } finally {
    // Both cleanups belong here rather than after the click: a throwing `click` would otherwise leave
    // the anchor in the document and the URL held for the life of the page.
    anchor.remove()
    // Download initiation is async; revoking synchronously can race it and produce an empty file.
    // Same reasoning as api/utils.ts downloadAttachment.
    setTimeout(() => URL.revokeObjectURL(url), 0)
  }
}
